module.exports = __webpack_public_path__ + "static/media/mostar.0bfad368.jpg";